export enum AffinisHeaderColumn {
  Filter = 'filter',
  MultiSelectFilter = 'multiSelectFilter',
  ValueType = 'valueType',
}

export enum AffinisCellTemplateKey {
  Edit = 'edit',
  Input = 'input',
  Select = 'select',
  MultiSelect = 'multiSelect',
  Label = 'label',
  Number = 'Number',
  Checkbox = 'checkbox',
}
